var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M4.667 10H3.333v1.333h1.334zM6.667 10H5.333v1.333h1.334zM8.667 10H7.333v1.333h1.333zM10.667 10H9.333v1.333h1.333zM6.667 8H5.333v1.333h1.334zM8.667 8H7.333v1.333h1.333zM10.667 8H9.333v1.333h1.333zM4.667 12H3.333v1.333h1.334zM6.667 12H5.333v1.333h1.334zM8.667 12H7.333v1.333h1.333zM10.667 12H9.333v1.333h1.333zM12.667 10h-1.334v1.333h1.333zM12.667 8h-1.334v1.333h1.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M15.333 1.333h-2.667V0h-1.333v1.333H4.667V0H3.333v1.333H.667V16h14.666zm-12 1.334V4h1.334V2.667h6.666V4h1.333V2.667H14v2.666H2V2.667zM2 14.667v-8h12v8z"
  })));
};
export default SvgCalendar;